import React, { useMemo } from 'react';
import { ChecklistDataEntry, StudentChecklistValue, TruckChecklistType } from './types';
import { createColumnHelper } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';
import ChecklistValueCell from './ChecklistValueCell';
import Table from './Table';

type TruckChecklistDataEntry = ChecklistDataEntry & {
	healthDeclaration: StudentChecklistValue;
	medicalCheck: StudentChecklistValue;
	RVM1C: StudentChecklistValue;
	VM2C: StudentChecklistValue;
	VM3C: StudentChecklistValue;
	closedArea: StudentChecklistValue;
	practicalTest: StudentChecklistValue;
	practicalExam: StudentChecklistValue;
};

const columnHelper = createColumnHelper<TruckChecklistDataEntry>();
const TruckChecklist = ({ checklist }: { checklist: TruckChecklistType }) => {
	const { t } = useTranslation();

	const columns = useMemo(() => {
		return [
			columnHelper.accessor('student.lastName', {
				header: t('employees.lastName'),
			}),
			columnHelper.accessor('student.firstName', {
				header: t('employees.firstName'),
			}),
			columnHelper.accessor('healthDeclaration', {
				header: 'Gezondheidsverklaring',
				cell: ChecklistValueCell,
			}),
			columnHelper.accessor('medicalCheck', {
				header: 'Medische Keuring',
				cell: ChecklistValueCell,
			}),
			columnHelper.accessor('RVM1C', {
				header: 'RVM1 C',
				cell: ChecklistValueCell,
			}),
			columnHelper.accessor('VM2C', {
				header: 'VM2 C',
				cell: ChecklistValueCell,
			}),
			columnHelper.accessor('VM3C', {
				header: 'VM3 C',
				cell: ChecklistValueCell,
			}),
			columnHelper.accessor('closedArea', {
				header: 'Besloten Terrein',
				cell: ChecklistValueCell,
			}),
			columnHelper.accessor('practicalTest', {
				header: 'Praktische Toets',
				cell: ChecklistValueCell,
			}),
			columnHelper.accessor('practicalExam', {
				header: 'Praktijkexamen',
				cell: ChecklistValueCell,
			}),
		];
	}, []);

	const data = useMemo(() => {
		return checklist.checklists.map((entry) => ({
			student: entry.student,
			healthDeclaration: entry.values.find(
				(value) => value.option.name === 'Gezondheidsverklaring',
			) || { value: null },
			medicalCheck: entry.values.find((value) => value.option.name === 'Medische Keuring') || {
				value: null,
			},
			RVM1C: entry.values.find((value) => value.option.name === 'RVM1 C') || { value: null },
			VM2C: entry.values.find((value) => value.option.name === 'VM2 C') || { value: null },
			VM3C: entry.values.find((value) => value.option.name === 'VM3 C') || { value: null },
			closedArea: entry.values.find((value) => value.option.name === 'Besloten Terrein') || {
				value: null,
			},
			practicalTest: entry.values.find((value) => value.option.name === 'Praktische Toets') || {
				value: null,
			},
			practicalExam: entry.values.find((value) => value.option.name === 'Praktijkexamen') || {
				value: null,
			},
		}));
	}, [checklist]);

	return <Table data={data} columns={columns} />;
};

export default TruckChecklist;
